"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ratingClassNames: function() {
        return ratingClassNames;
    },
    useRatingStyles_unstable: function() {
        return useRatingStyles_unstable;
    }
});
const _react = require("@griffel/react");
const ratingClassNames = {
    root: 'fui-Rating'
};
/**
 * Styles for the root slot
 */ const useRootClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r2imjyh", null, [
    ".r2imjyh{display:flex;flex-wrap:wrap;}"
]);
const useRatingStyles_unstable = (state)=>{
    'use no memo';
    const rootClassName = useRootClassName();
    state.root.className = (0, _react.mergeClasses)(ratingClassNames.root, rootClassName, state.root.className);
    return state;
}; //# sourceMappingURL=useRatingStyles.styles.js.map
